/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Loading,Notify,LocalStorage,Dialog} from 'quasar'



export default { config: {"loading":{"spinnerColor":"yellow-8"},"notify":{"position":"top"}},plugins: {Loading,Notify,LocalStorage,Dialog} }

